import { createAction, handleActions } from 'redux-actions';
import { Record, Map, List } from 'immutable';
import { pender } from 'redux-pender';

import { camelizeObjKeys } from '~/utils/CamelizeUtils.js';
import * as api from '~/lib/api';

const GET_REVIEWABLE = 'reviewForm/GET_REVIEWABLE';
const SUBMIT = 'reviewForm/SUBMIT';

export const getReviewable = createAction(GET_REVIEWABLE, userId => {
  return api.getReviewable();
});

export const submit = createAction(SUBMIT, (agentId, inputs) => {
  return api.submitReview({
    id: agentId,
    inputs,
  });
});

const Agent = Record({
  id: 0,
  name: '',
  reviewed: false,
});

const initialState = Record({
  reviewable: List(),
  submitReviewError: null,
})();

export default handleActions(
  {
    ...pender({
      type: GET_REVIEWABLE,
      onSuccess: (state, { payload: response }) => {
        const data = camelizeObjKeys(response.data);
        return state.set(
          'reviewable',
          List(data.agents.map(agent => Agent(agent)))
        );
      },
    }),
    ...pender({
      type: SUBMIT,
      onSuccess: state => {
        window.analytics.track('TaxAgent Review Added');

        return state;
      },
      onFailure: (state, { payload: response }) => {
        const camelized = camelizeObjKeys(response);
        return state.set(
          'submitReviewError',
          Map(camelized.response.data.errors)
        );
      },
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/store/modules/reviewForm.js